import { SxProps, Theme } from "@mui/material";

const common = (theme: Theme) => ({
  container: {},

  title: {
    mb: "calc(0.5 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      ml: "var(--rhythm)",
      mb: "calc(1 * var(--rhythm))",
    },
  },

  card: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "calc(2 * var(--rhythm))",
    padding: "calc(2 * var(--rhythm))",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "calc(1 * var(--rhythm))",
      p: "var(--rhythm)",
      borderRadius: 0,
    },
  },

  image: {
    flex: "1 1 auto",
    width: "50%",
    height: "calc(10 * var(--rhythm))",
    objectFit: "contain",
    objectPosition: "center center",
    [theme.breakpoints.down("md")]: {},
  },

  table: {
    flex: "0 1 auto",
    width: "50%",
    letterSpacing: "2px",
    fontWeight: 100,
    border: "none",
    ".MuiTableRow-root": {
      width: "50%",
      background: "var(--color-white)",
      borderBottom: "1px solid var(--color-border)",
    },
    ".MuiTableCell-root": {
      paddingY: "calc(0.5 * var(--rhythm))",
      background: "var(--color-white)",
      border: "none",
      "&:last-child": {
        fontSize: "var(--font-size-l)",
        letterSpacing: 0,
        textAlign: "right",
      },
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
});

export default (theme: Theme): Record<string, Record<string, SxProps<Theme>>> => ({
  LightingCalculation: {
    container: {
      mt: "var(--rhythm)",
    },

    title: {
      mb: "calc(0.5 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        ml: "var(--rhythm)",
        mb: "calc(1 * var(--rhythm))",
      },
    },

    card: {
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.down("md")]: {
        borderRadius: 0,
      },
    },

    form: {
      flexDirection: "column",
      margin: 0,
      padding: "calc(2 * var(--rhythm))",
      border: "none",
      [theme.breakpoints.down("md")]: {
        padding: "calc(1 * var(--rhythm))",
      },
    },

    header: {
      position: "relative",
      top: "calc(2 * var(--rhythm))",
      display: "flex",
      flexDirection: "row",
      alignContent: "center",
      justifyContent: "flex-start",
      gap: "calc(2 * var(--rhythm))",
      width: "100%",
      margin: "0 0 calc(2 * var(--rhythm)) 0",
      padding: 0,
      fontWeight: "bold",
      [theme.breakpoints.down("md")]: {
        top: "calc(1 * var(--rhythm))",
        justifyContent: "space-between",
        mb: "var(--rhythm)",
      },
    },

    paste: {
      height: "auto",
      padding: "calc(0.25 * var(--rhythm)) calc(0.5 * var(--rhythm))",
      // "&:hover": {
      //   background: "transparent",
      // },
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "calc(1.5 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        display: "flex",
        flexDirection: "column",
        gap: "calc(1 * var(--rhythm))",
      },
    },

    buttons: {
      mt: "calc(2 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        mt: "calc(1 * var(--rhythm))",
      },
    },
  },

  DownloadLinks: {
    buttons: {
      flexDirection: "row",
      gap: "var(--rhythm)",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
    },
  },

  RoadwayInfo: {
    ...common(theme),
  },

  LuminaireRow: {
    ...common(theme),

    chip: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "var(--rhythm)",
      height: "var(--rhythm)",
      textAlign: "center",
      letterSpacing: 0,
      color: "var(--color-white)",
      background: "var(--color-grey)",
      borderRadius: "50%",
    },
  },

  LuminaireFound: {
    ...common(theme),

    image: {
      ...common(theme).image,
      width: "33%",
    },

    caption: {
      captionSide: "top !important",
      mb: "var(--rhythm) !important",
      padding: "0 !important",
      letterSpacing: "0 !important",
      fontWeight: "bold !important",
      color: "var(--color-black) !important",
    },
  },
});
